<template>
  <div class="form-row">
    <div class="form-group col-12">
      <p class="font-weight-bold">Select Sound</p>
      <div class="models-wrapper">
        <div v-for="(sound, key) in media"
             :key="key"
             class="model-item"
        >
            <div class="col-1">
              <button v-if="sound.hasOwnProperty('showStopButton') && !sound.showStopButton" @click="playSound(key)"
                class="btn btn-outline-success" id="select_audio_duration_s">
                <i class="fa fa-play"></i>
              </button>
              <button v-else @click="stopSound(key)"
                class="btn btn-outline-danger" id="select_audio_duration_e">
                <i class="fa fa-stop"></i>
              </button>
            </div>
            <div class="col-1">
              <button
                @click="changeSelectedModel(key, sound)"
                class="btn btn-primary"
              >
                Select
              </button>
            </div>
            <p>{{ sound.name }}</p>
          </div>
        </div>
    </div>
  </div>
  
</template>
<script>

import { mapActions, mapState } from 'vuex'
import { uuid } from 'vue-uuid'

export default {
  components: {},
  data () {
    return {
      activeSound: 'Select Sound',
      sampleSound: '',
      mediaSounds: null,
      end_duration: 0
    }
  },

  methods: {
    changeSelectedModel (index, sound) {
      this.activeSound = sound.name
      this.characters.map((char) => ({ ...char, active: false }))
      let selectedOne = {
        type: 'Sound',
        objectName: sound.name,
        objectId: uuid.v1(),
        objectDbHash: index,
        mediaLength: 0,
        audioType: sound.audioType || 'MPEG',
        startTime: 0,
        endTime: 0,
        volume: sound.volume || 0.5,
        loopCount: sound.loopCount || 1,
        soundType: sound.soundType || "2D",
        audioUrl:
          sound.audio.audioURL,
        pitch: sound.pitch || 1,
        spatialBlend: sound.spatialBlend || '',
        minimumDistance: sound.minimumDistance || 0,
        maximumDistance: sound.maximumDistance || 0,
        active: true,
        duration: 0,
      }

      this.$store.dispatch('updateCharacters', [
        ...this.characters.map((char) => ({ ...char, active: false})),
        selectedOne
      ])

      this.$emit('triggerSelectedModel', { index, sound })
      if (this.sampleSound) {
        this.sampleSound.stop()
      }
      this.$emit('closePopup') 
    },
    onLoadEvent () {
      this.end_duration = this.sampleSound.duration(0).toFixed(2)
    },
    playSound (value) {
      if (this.sampleSound) {
        this.sampleSound.stop()
      }

      for (let index in this.mediaSounds) {
        this.mediaSounds[index] = {
          ...this.mediaSounds[index],
          showStopButton : index  == value ? true : false
        }
      }
      this.sampleSound = new Howl({
        src: [this.mediaSounds[value].audio.audioURL],
        format: ['mp3'],
        volume: 0.5,
        onend: function () {
          this.sampleSound = null;
          this.mediaSounds[value] = {
          ...this.mediaSounds[value],
          showStopButton : false
        }
        }.bind(this),
      })
      this.sampleSound.play()
    },
    stopSound (index) {
      this.mediaSounds[index].showStopButton = false
      this.sampleSound.stop()
    },
  },
  mounted() {
    this.mediaSounds = this.sounds
  },
  computed: {
    ...mapState([
      'sounds',
      'characters'
    ]),
    media() {
      return this.mediaSounds
    }
  }
}
</script>
<style scoped lang="scss">
button {
  width: 75px;
}

i {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline-components/sounds.vue